import { Injectable } from '@angular/core';

export interface ChildrenItems {
  state: string;
  name: string;
  type?: string;
  subchildren?: SuperChildrenItems[];
}

export interface SuperChildrenItems {
  state: string;
  name: string;
  type?: string;
}

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  children?: ChildrenItems[];
}

const HORIZONTALMENUITEMS = [
  {
    state: 'home',
    name: 'HOME',
    type: 'link',
    icon: 'home'
  },
  {
    state: 'admin',
    name: 'ADMIN',
    type: 'sub',
    icon: 'web',
    children: [
      // { state: 'login', name: 'LOGIN' },
      // { state: 'register', name: 'REGISTER' },
      // { state: 'forgot-password', name: 'FORGOT' },
      // { state: 'lockscreen', name: 'LOCKSCREEN' }
      { state: 'users', name: 'USERS' },
      { state: 'roles', name: 'ROLES' },
      { state: 'rate', name: 'RATE' }
    ]
  },
  {
    state: 'cmr',
    name: 'CMR',
    type: 'sub',
    icon: 'important_devices',
    children: [
      { state: 'contacts', name: 'CONTACTS' },
      { state: 'companies', name: 'COMPANIES' },
      { state: 'media', name: 'MEDIA' },
      { state: 'customers', name: 'CUSTOMERS' },
      { state: 'spokesmen', name: 'SPOKESMEN' },
      { state: 'campaigns', name: 'CAMPAIGNS' },
      { state: 'press-release', name: 'PRESS RELEASE' },
      { state: 'media-plan', name: 'MEDIA PLAN' }
    ]
  },
  {
    state: 'reports',
    name: 'REPORTS',
    type: 'sub',
    icon: 'assignment',
    children: [
      { state: 'generate-report', name: 'GENERATE REPORT' },
      { state: 'reports-list', name: 'REPORTS LIST' },
      { state: 'platform-impacts', name: 'PLATFORM IMPACTS' },
      { state: 'graph-impacts-by-platforms', name: 'GRAPH IMPACTS BY PLATFORMS' },
      { state: 'status-by-campaign-or-spokesperson', name: 'STATUS BY CAMPAIGN OR SPOKESPERSON' }
    ]
  },
  {
    state: 'expert-system',
    name: 'EXPERT SYSTEM',
    type: 'sub',
    icon: 'language',
    children: [
      { state: 'load-knowledge-database', name: 'LOAD KNOWLEDGE DATABASE' }
    ]
  },
  {
    state: 'maintenance',
    name: 'MAINTENANCE',
    type: 'link',
    icon: 'build'
  }
  // {
  //   state: 'error',
  //   name: 'ERROR',
  //   type: 'sub',
  //   icon: 'error_outline',
  //   children: [
  //     { state: '404', name: '404' },
  //     { state: '503', name: '503' }
  //   ]
  // }
];

@Injectable()
export class HorizontalMenuItems {
  getAll(): Menu[] {
    return HORIZONTALMENUITEMS;
  }
  add(menu: Menu) {
    // HORIZONTALMENUITEMS.push(Menu);
  }
}
